import type { ContainerAccess } from "@/types/session";

/**
 * Map the snake_case container item returned by `GET /auth/containers` to the
 * camelCase `ContainerAccess` shape. The Teams Stream 1 canonical fields
 * (`type`/`planTier`/`role`) arrive already mapped by the API (`@xavior/domain`),
 * so they pass through unchanged — never re-mapped on the client.
 */
export function mapContainerFromList(c: any): ContainerAccess {
  return {
    id: c.id,
    ownerId: c.owner_id,
    ownerEmail: c.owner_email,
    ownerName: c.owner_name || null,
    containerName: c.container_name || null,
    isOwner: c.is_owner,
    permission: c.permission,
    memberSince: c.member_since || null,
    type: c.type,
    planTier: c.planTier,
    role: c.role,
    onboardingState: c.onboardingState,
    onboardingCompleted: c.onboardingCompleted,
    memberCount: typeof c.member_count === 'number' ? c.member_count : undefined,
    nameSetByUser: c.nameSetByUser ?? null,
  };
}

/**
 * Map the camelCase container returned by `POST /auth/select-container` to
 * `ContainerAccess`. Same canonical-field pass-through as
 * {@link mapContainerFromList}.
 */
export function mapContainerFromSelect(c: any): ContainerAccess {
  return {
    id: c.id,
    ownerId: c.ownerId,
    ownerEmail: c.ownerEmail,
    ownerName: c.ownerName,
    containerName: c.containerName || null,
    isOwner: c.isOwner,
    permission: c.permission,
    type: c.type,
    planTier: c.planTier,
    role: c.role,
    onboardingState: c.onboardingState,
    onboardingCompleted: c.onboardingCompleted,
    nameSetByUser: c.nameSetByUser ?? null,
  };
}
